import styled, { css } from 'styled-components';

import InnerContainer from '../components/landing/InnerContainer';

export const FullHeightDiv = styled.div`
  height: 100vh;
  position: relative;
  overflow: hidden;
  & video {
    height: 100%;
    width: auto !important;
  }
  ${({ backgroundImage }) =>
    backgroundImage &&
    css`
      background-image: url(${({ backgroundImage }) => backgroundImage});
      background-repeat: no-repeat;
      background-size: cover;
      background-position-x: ${({ backgroundPositionX }) => backgroundPositionX || 0};
      background-position-y: ${({ backgroundPositionY }) => backgroundPositionY || 0};
    `};
  ${({ isMobile }) =>
    isMobile
      ? css`
          width: 100vw;
        `
      : css`
          width: 100%;
          min-height: 900px;
        `};
`;

export const ArtistName = styled.div`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 150%;
  color: ${props => props.theme.palette['white']};
  position: absolute;
  left: 55px;
  bottom: 35px;
  text-align: left;
  ${props =>
    props.isMobile
      ? css`
          display: none;
        `
      : css`
          display: block;
        `}
`;

export const Stack = styled.div`
  display: flex;
  flex-direction: ${props => (props.direction === 'vertical' ? 'column' : 'row')};
  gap: ${props => (props.spacing ? props.theme.spacing(props.spacing) : props.theme.spacing(3))};
`;

export const Spacing = styled.div`
  width: 100%;
  height: ${props => (props?.spacing ? props.theme.spacing(props.spacing) : props.theme.spacing(5))};
`;

export const Thumbnail = styled.img`
  width: 259px;
  height: 146px;
  object-fit: cover;
`;

export const BackgroundContainer = styled(InnerContainer)`
  ${({ isMobileUA, backgroundImage }) =>
    isMobileUA &&
    backgroundImage &&
    css`
      height: 100%;
      background-image: url(${({ backgroundImage }) => backgroundImage});
      background-repeat: no-repeat;
      background-size: cover;
      background-position-x: ${({ backgroundPositionX }) => backgroundPositionX || 0};
      background-position-y: ${({ backgroundPositionY }) => backgroundPositionY || 0};
    `}
`;
